import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/nuxt-assets/images/discussions/bronze_shield.svg")